import { NEIGHBORHOOD_OPTIONS, isExtraZone } from "../lib/constants";

export const ZoneSelect = ({ neighborhood, zoneText, onNeighborhood, onZoneText, selectClass, inputClass, testid }) => (
  <div className="space-y-2">
    <select data-testid={`${testid}-neighborhood`} value={neighborhood} onChange={(e) => onNeighborhood(e.target.value)} className={selectClass}>
      <option value="">Nessun quartiere</option>
      {NEIGHBORHOOD_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
    </select>
    {isExtraZone(neighborhood) && (
      <input data-testid={`${testid}-zone-text`} value={zoneText} onChange={(e) => onZoneText(e.target.value)} maxLength={80}
        placeholder="Comune o zona, es. Segrate, Rho, Idroscalo" className={inputClass} />
    )}
  </div>
);
